  export const Configuration = {
    environmentName: "dev",
    logLevel: "debug",
    version: {
      long: "26.11.1+261103211419.gb1fec60ee",
      short: "26.11.1"
    }
  };
